import React, { Component } from 'react';

export default class UnitySplitPane extends Component {
  constructor(props) {
    super(props);
    this.splitPaneRef = React.createRef();
  }

  componentDidMount() {
    this.updateProperties();
  }

  componentDidUpdate() {
    this.updateProperties();
  }

  updateProperties() {
    const { props, splitPaneRef } = this;
    const unitySplitPane = splitPaneRef.current;
    const {
      header,
      main,
      pane,
      footer,
      onClose,
      onResize,
      onCollapseChange,
      show,
      closeButton,
      collapseButton,
      collapsed,
    } = props;
    if (unitySplitPane) {
      unitySplitPane.onClose = onClose || (() => {});
      unitySplitPane.onResize = onResize || (() => {});
      unitySplitPane.onCollapseChange = onCollapseChange || (() => {});
      unitySplitPane.header = header;
      unitySplitPane.main = main;
      unitySplitPane.pane = pane;
      unitySplitPane.footer = footer;
      if (show) unitySplitPane.show = show;
      if (closeButton) unitySplitPane.closeButton = closeButton;
      if (collapseButton) unitySplitPane.collapseButton = collapseButton;
      if (collapsed) unitySplitPane.collapsed = collapsed;
    }
  }

  render() {
    const {
      header,
      main,
      pane,
      footer,
      show,
      closeButton,
      collapsed,
      collapseButton,
      ...otherProps
    } = this.props;
    let splitPaneArgs = { ...otherProps };

    if (show) splitPaneArgs.show = show;
    if (closeButton) splitPaneArgs.closeButton = closeButton;
    if (collapseButton) splitPaneArgs.collapseButton = collapseButton;
    if (collapsed) splitPaneArgs.collapsed = collapsed;

    return (
      <unity-split-pane className="usp-wrapper" ref={this.splitPaneRef} {...splitPaneArgs}>
        <div slot="header" style={{ flex: 1, width: '100%' }}>
          {header}
        </div>
        <div slot="main" style={{ height: '100%', display: 'flex', overflow: 'hidden' }}>
          {main}
        </div>
        <div slot="pane" style={{ height: '100%', display: 'flex', overflow: 'hidden', zIndex: 3 }}>
          {pane}
        </div>
        <div slot="footer">
          {footer}
        </div>
      </unity-split-pane>
    );
  }
}